p {
  margin: 0;
  color: var(--lgr-color-neutral-low-pure);
  font-family: var(--lgr-font-family-regular);
  text-overflow: inherit;
  white-space: inherit;
  overflow: inherit;

  &.inverse {
    color: var(--lgr-color-neutral-high-pure);
  }

  &.large {
    font-size: var(--lgr-content-size-primary);
  }

  &.small {
    font-size: var(--lgr-content-size-secondary);
  }

  &.x-small {
    font-size: var(--lgr-content-size-tertiary);
  }
}

strong {
  p {
    font-family: var(--lgr-font-family-bold);
  }
}
